import { isNegative } from './number.js';

/**
 * Takes a value in cents, and outputs a value in dollars.
 *
 * Example:
 * - 100 => 1
 * - 161 => 1.61
 * - 161.5 => 1.62
 * - 14565 => 145.65
 */

const convertCentsToDollar = cents => Math.round(cents) / 100;
/**
 * Takes a value in cents, and outputs a formatted value in dollars.
 *
 * Example:
 * - 100 => $1
 * - 110 => $1.10
 * - 161 => $1.61
 * - 161.5 => $1.62
 * - 14565 => $145.65
 *
 * Always show cents:
 * - 100 => $1.00
 *
 * Negative value:
 * - -1530 => -$15.30
 */

const formatCentsToDollar = (cents, alwaysShowCents = false) => {
  const absCents = Math.abs(cents);
  const dollars = convertCentsToDollar(absCents);
  const hasCents = !!(dollars % 1);
  const negativeSign = isNegative(cents) ? '-' : '';
  const dollarsStr = alwaysShowCents || hasCents ? dollars.toFixed(2) : String(dollars);
  return `${negativeSign}$${dollarsStr}`;
};
/**
 * Takes a value in dollars, and outputs a value in cents.
 *
 * Example:
 * - 1 => 100
 * - 15 => 1500
 * - 151.42 => 15142
 */

const convertDollarsToCents = dollars => {
  const amountInCents = dollars * 100;
  /**
   * Round the value to the nearest integer due to floating point
   * arithmetic errors.
   *
   * Example: 151.42 * 100 = 15141.999999999998
   * Corrected: 15142
   */

  const correctedAmount = Number(amountInCents.toFixed());
  return correctedAmount;
};

export { convertCentsToDollar, convertDollarsToCents, formatCentsToDollar };
